const features = [
  {
    id: 1,
    icon: 'ri-notification-3-line',
    title: '实时追更提醒',
    desc: '收藏漫画后自动订阅更新通知，新章节上线第一时间提醒，追更永不错过。',
  },
  {
    id: 2,
    icon: 'ri-bookmark-line',
    title: '智能收藏管理',
    desc: '按分类、更新状态智能整理收藏夹，几百部追更漫画也能一目了然。',
  },
  {
    id: 3,
    icon: 'ri-double-quotes-r',
    title: '下拉式阅读',
    desc: '告别翻页点击，上滑即可连续阅读。流畅沉浸的阅读体验，一口气看过瘾。',
  },
  {
    id: 4,
    icon: 'ri-magic-line',
    title: 'AI 智能推荐',
    desc: '基于你的阅读偏好和行为数据，精准推荐你可能喜欢的漫画新作。',
  },
  {
    id: 5,
    icon: 'ri-global-line',
    title: '海量漫画大全',
    desc: '收录超 5 万部韩漫日漫，涵盖热血、恋爱、奇幻、悬疑等全品类。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">追漫体验</h2>
          <p className="mt-2 text-sm text-foreground-500">五大核心功能，打造极致追漫体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.slice(0, 3).map((feature) => (
            <div key={feature.id} className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.slice(3).map((feature) => (
              <div key={feature.id} className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-accent-500`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}